export const Qualification = 0
export const Experience = 1
